import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Explore Careers | ShipSticks',
  description:
    "We're changing the way golfers travel - and having a lot of fun doing it. " +
    'Check out open roles at ShipSticks and find your next great opportunity.',
  alternates: {
    canonical: 'https://www.shipsticks.com/careers',
  },
}

export default metadata
